<div id="add-calendar" class="add-calendar">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Población de {{regionName}} </h2>
    </div>
    <form [formGroup]="labourService.poblacionForm"  role="form">
        <div class="popoup-content">
            <div class="block-looper">
                <mat-label class="label">Nombre</mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <textarea formControlName="Poblacion" maxlength="100" matInput></textarea>
                </mat-form-field>
                <mat-error
                    *ngIf="labourService.poblacionForm.get('Poblacion').invalid && labourService.poblacionForm.get('Poblacion').touched">
                    <span *ngIf="labourService.poblacionForm.get('Poblacion').hasError ">La población es obligatoria</span>
                </mat-error>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSubmit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" type="button" (click)="onClose()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>